import Middleware  from './Middleware';

/**
 * A facade between the `Middleware` instance and consumer, ensuring that
 * only the necessary methods and properties are exposed to the consumer.
 */

class MiddlewareFacade {
    constructor(wrapper, options) {
        const middleware = new Middleware(wrapper, options);

        this.configure = middleware.configure.bind(middleware);
        this.loadAsset = middleware.loadAsset.bind(middleware);
        this.fadeInVolume = middleware.fadeInVolume.bind(middleware);
        this.fadeOutVolume = middleware.fadeOutVolume.bind(middleware);
        this.showControls = middleware.showControls.bind(middleware);
        this.hideControls = middleware.hideControls.bind(middleware);
        this.destroy = middleware.destroy.bind(middleware);
        this.exitFullscreen = middleware.exitFullscreen.bind(middleware);

        Object.defineProperties(this, {
            state: {
                get: () => middleware.state,
            },
            legacyShim$: {
                get: () => middleware.legacyShim$,
            },
            playerInteractions$: {
                get: () => middleware.playerInteractions$,
            },
        });
    }
}

export default MiddlewareFacade;
